"use client";
import {
  Button,
  MantineProvider,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import WestRounded from "@mui/icons-material/WestRounded";
import { getCoreThemeColors } from "@utils/helpers";
import Image from "next/image";
import { useRouter } from "next/navigation";
import classes from "./not-found.module.css";

export default function NotFound() {
  const router = useRouter();
  const themeColors = getCoreThemeColors();

  return (
    <MantineProvider defaultColorScheme="light">
      <Paper className={classes.wrapper} radius={0}>
        <Stack align="center" gap="xl" w="100%">
          <Image
            src="/static/images/permissions/notfoundbanner.svg"
            alt="404 Not Found"
            width={750}
            height={400}
            style={{
              maxWidth: "90vw",
              height: "auto",
            }}
          />
          <Stack gap="md" align="center" style={{ maxWidth: "500px" }}>
            <Title order={1} fw={600} c={themeColors.darkblue[5]} ta="center">
              You have found a secret place!
            </Title>
            <Text
              size="md"
              c={themeColors.darkblue[9]}
              ta="center"
              style={{ lineHeight: 1.6 }}
            >
              Unfortunately, this is only a 404 page. You may have mistyped the
              address, or the page has been moved to another URL.
            </Text>
          </Stack>

          <Button
            name="Back"
            size="md"
            onClick={() => router.back()}
            leftSection={<WestRounded />}
            className={classes.backButton}
          >
            Go Back
          </Button>
        </Stack>
      </Paper>
    </MantineProvider>
  );
}
